const toLocale = function (dataObject, dateTimeName, dateTimeNameLoc) {
  const dateDate = new Date(dataObject[dateTimeName] + ' GMT-0000')
  dataObject[dateTimeNameLoc] = dateDate.toLocaleString()
  return dataObject
}
const toLocaleDate = function (dateTime) {
  const dateDate = new Date(dateTime + ' GMT-0000')
  return dateDate.toLocaleString()
}
const toLocaleDateTime = function (dateTime) {
  const dateDate = new Date(dateTime + ' GMT-0000')
  return dateDate
}
export { toLocale, toLocaleDate, toLocaleDateTime }
